var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 120,
    viewBox: "0 0 162 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 43C24 31.9543 32.9543 23 44 23V23C55.0457 23 64 31.9543 64 43V73H24V43Z",
    fill: "#777081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7 15.7909 8.79086 14 11 14V14C13.2091 14 15 15.7909 15 18V114C15 116.209 13.2091 118 11 118V118C8.79086 118 7 116.209 7 114V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75H86V79.5L76 84L86 88.5V107H21V88.5L31 84L21 79.5V75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41C53 45.4183 49.4183 49 45 49C40.5817 49 37 45.4183 37 41C37 36.5817 40.5817 33 45 33C49.4183 33 53 36.5817 53 41Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41C84 45.4183 80.4183 49 76 49C71.5817 49 68 45.4183 68 41C68 36.5817 71.5817 33 76 33C80.4183 33 84 36.5817 84 41Z",
    fill: "#777081"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 60.75C34 55.3652 38.701 51 44.5 51C50.299 51 55 55.3652 55 60.75V73H34V60.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71L42 68L43 60L47 60L48 68L45 71Z",
    fill: "#777081"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58C43.8954 58 43 57.1046 43 56V56C43 54.8954 43.8954 54 45 54V54C46.1046 54 47 54.8954 47 56V56C47 57.1046 46.1046 58 45 58V58Z",
    fill: "#777081"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60.75C67 55.3652 71.0294 51 76 51C80.9706 51 85 55.3652 85 60.75V73H67V60.75Z",
    fill: "#777081"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84H47V99H43V84Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84H64V99H60V84Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6094 84.7734L53.4731 83.7382L57.3554 98.227L53.4917 99.2623L49.6094 84.7734Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70L73 67L74 59L78 59L79 67L76 70Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57C74.8954 57 74 56.1046 74 55V55C74 53.8954 74.8954 53 76 53V53C77.1046 53 78 53.8954 78 55V55C78 56.1046 77.1046 57 76 57V57Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104 27H152V54H104V27Z",
    fill: "#777081"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118 59H126V78H118V59Z",
    fill: "#777081"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131 59H139V78H131V59Z",
    fill: "#777081"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114C21 111.791 22.7909 110 25 110H82C84.2091 110 86 111.791 86 114V114C86 116.209 84.2091 118 82 118H25C22.7909 118 21 116.209 21 114V114Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17C7 14.7909 8.79086 13 11 13H148C150.209 13 152 14.7909 152 17V17C152 19.2091 150.209 21 148 21H11C8.79086 21 7 19.2091 7 17V17Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158 87C158 91.4183 154.418 95 150 95C145.582 95 142 91.4183 142 87C142 82.5817 145.582 79 150 79C154.418 79 158 82.5817 158 87Z",
    fill: "#777081"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139 108.424C139 102.115 144.149 97 150.5 97C156.851 97 162 102.115 162 108.424V110C162 112.209 160.209 114 158 114H143C140.791 114 139 112.209 139 110V108.424Z",
    fill: "#777081"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133 91C133 95.4183 129.418 99 125 99C120.582 99 117 95.4183 117 91C117 86.5817 120.582 83 125 83C129.418 83 133 86.5817 133 91Z",
    fill: "#777081"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114 112.424C114 106.115 119.149 101 125.5 101C131.851 101 137 106.115 137 112.424V114C137 116.209 135.209 118 133 118H118C115.791 118 114 116.209 114 114V112.424Z",
    fill: "#777081"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108 87C108 91.4183 104.418 95 100 95C95.5817 95 92 91.4183 92 87C92 82.5817 95.5817 79 100 79C104.418 79 108 82.5817 108 87Z",
    fill: "#777081"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108.424C89 102.115 94.1487 97 100.5 97C106.851 97 112 102.115 112 108.424V110C112 112.209 110.209 114 108 114H93C90.7909 114 89 112.209 89 110V108.424Z",
    fill: "#777081"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.871 35.8403L116 49.2857H138.857V31L133.43 40.2852L129.43 33.7852L124.93 40.2852L120.871 35.8403Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.e762fb71.svg";
export { ForwardRef as ReactComponent };